import { Typography } from '@mui/material'
import { DateTime } from 'luxon'

type Props = {
  dateTime: Date | string | null | undefined
  format?: string
}
export const DateTimeFormat = ({ dateTime, format }: Props) => {
  if (!dateTime) return <Typography component="span" variant="body2" />

  const fmt = format ?? 'yyyy年MM月dd日 HH:mm'

  let formatDate = ''
  if (typeof dateTime === 'string') {
    formatDate = DateTime.fromISO(dateTime).toFormat(fmt)
  } else {
    formatDate = DateTime.fromJSDate(dateTime).toFormat(fmt)
  }
  return (
    <Typography component="span" variant="body2">
      {formatDate}
    </Typography>
  )
}
